// extracted by mini-css-extract-plugin
export default {"information":"infoWarning_information__HGeT8","hintIcon":"infoWarning_hintIcon__yXiKB","tableText":"infoWarning_tableText__qCKMg"};